"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContext = createContext;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _events = require("events");
var _store = require("../store");
var _context = require("./context");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createContext(options, preloadedState) {
  const context = (0, _extends2.default)({}, ((0, _objectDestructuringEmpty2.default)(options), options));
  const {
    config
  } = context;
  const emitter = new _events.EventEmitter();
  const preparedPreloadedState = (0, _utils.getPreparedPreloadedState)(config);
  const getPreloadedState = (0, _utils.deepMerge)(preparedPreloadedState, preloadedState);
  const store = (0, _store.createStore)({
    context: _objectSpread(_objectSpread({}, context), {}, {
      emitter
    }),
    preloadedState: getPreloadedState
  });
  return new _context.AuthenticationContext(store, emitter);
}